import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker"
export { wrapRootElement } from "./gatsby-shared"
CheckWebpFeature()
